<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Logo',
})
</script>
<template>
  <div class="logo">
    <router-link :to="{ name: 'dashboard' }">
      <SvgIcon name="logo" />
      <h1 v-if="showTitle">{{ title}}</h1>
    </router-link>
  </div>
</template>

<script lang="ts" setup name="Logo">
import SvgIcon from '@/components/SvgIcon/index.vue'
import defaultConfig from '@/config/defaultSettings'
import {ref} from 'vue'
const props = defineProps({
  title: {
    type: String,
    default:defaultConfig.title,
    required: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
    required: false,
  },
})
</script>
